import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';
// import { CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon } from '@material-ui/icons/CheckBoxOutlineBlank';
// import { CheckBox as CheckBoxIcon } from '@material-ui/icons/CheckBox';
import CloudDownload from '@material-ui/icons/CloudDownload';
import Fingerprint from '@material-ui/icons/Fingerprint';
import MusicNote from '@material-ui/icons/MusicNote';
import classnames from 'classnames';

import blue from '@material-ui/core/colors/blue';
import TimePicker from 'rc-time-picker';
import moment from 'moment';
import 'styles/time-picker.css';
import assign from 'lodash/assign';
// import uuidv1 from 'uuid/v1';
import { Close } from 'components/Icons';

const styles = theme => ({
  container: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(),
  },
  title: {
    fontSize: '1em',
    fontWeight: 'bold',
    color: '#000',
    marginBottom: 5,
  },
  subTitle: {
    fontSize: '0.8em',
    fontWeight: 'bold',
    color: '#bbb',
    marginBottom: 5,
  },
  topContainer: {
    display: 'flex',
    flexGrow: 1,
    // backgroundColor: '#Fd0',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  table: {
    width: '100%',
  },
  th: {
    height: 30,
  },
  tableContainer: {
    // backgroundColor: '#Fd0',
  },
  tableHeader: {
    // backgroundColor: '#F00',
    textAlign: 'left',
    padding: 10,
    fontSize: '0.8em',
    fontWeight: 'bold',
  },
  tableRow: {
    // backgroundColor: '#Fd0',
    fontSize: '0.9em',
  },
  bottomContainer: {
    display: 'flex',
    marginTop: 10,
    flexGrow: 1,
    // backgroundColor: '#F00',
    justifyContent: 'flex-end',
  },
  root: {
    color: blue[600],
    '&$checked': {
      color: blue[500],
    },
  },
  checked: {},
  size: {
    width: 30,
    height: 30,
  },
  sizeIcon: {
    fontSize: 20,
  },
  deleteButton: {
    cursor: 'pointer',
  },
  toneNumberRoot: {
    color: '#4EA2FF',
    fontSize: '1em',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  toneNumberNormal: {
    color: '#4EA2FF',
    fontSize: '1em',
  },
});

const Tone = ({ selected, tone, classes, setToneNumber, isRoot }) => {
  const isToneSet = tone.toneId;

  if (isRoot) {
    if (isToneSet) {
      return (
        <div
          className={classes.toneNumberRoot}
          onClick={() => setToneNumber(selected, tone)}
        >
          {tone.toneId}
        </div>
      );
    } else {
      return (
        <div
          className={classes.toneNumberRoot}
          onClick={() => setToneNumber(selected, tone)}
        >
          SET TONE
        </div>
      );
    }
  } else {
    return (
      <div className={classes.toneNumber}>
        {isToneSet && tone.toneId}
        {!isToneSet && 'NO TONE'}
      </div>
    );
  }
};

const Table = ({
  user,
  classes,
  selected,
  handleToneUpdate,
  confirmDelete,
  experiences,
  setToneNumber,
  isRoot,
}) => {
  return (
    <div className={classes.tableContainer}>
      <table className={classes.table}>
        <thead className={classes.tableHeader}>
          <tr className="border-solid border-b">
            <th className={classes.th}>TONE#</th>
            <th>TIME</th>
            <th>THROUGHT</th>
            <th>EXPERIENCE</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {selected &&
            selected.tones &&
            selected.tones.map(tone => {
              if (
                tone.hasOwnProperty('experience') &&
                typeof tone.experience === 'string'
              ) {
                const index = experiences.map(el => el._id).indexOf(tone.experience);
                if (index >= 0) {
                  tone.experience = experiences[index];
                }
              }
              let disableSelectExperience = true;
              if (selected.status === 'done') {
                disableSelectExperience = false;
              }

              return (
                <tr
                  className={classnames(classes.tableRow, 'border-solid border-b')}
                  key={tone._id}
                >
                  <td>
                    <Tone
                      user={user}
                      selected={selected}
                      tone={tone}
                      classes={classes}
                      setToneNumber={setToneNumber}
                      isRoot={isRoot}
                    />
                  </td>
                  <td>
                    <TimePicker
                      defaultValue={moment(tone.time, 'HH:mm:ss')}
                      value={moment().startOf('day').seconds(tone.time)}
                      style={{ ...styles.rcTimePickerPanelSelect, width: 70 }}
                      format="HH:mm:ss"
                      allowEmpty
                      showHour
                      showMinute
                      showSecond
                      use12Hours={false}
                      onChange={(value, event) => {
                        let time = 0;
                        if (value) {
                          time = moment.duration(value.format('HH:mm:ss')).asSeconds();
                          tone = assign(tone, { time });
                          handleToneUpdate(tone);
                        }
                      }}
                    />
                  </td>
                  <td>
                    <Checkbox
                      className={classes.size}
                      checked={tone.throught}
                      name="throught"
                      color="primary"
                      onChange={event => {
                        tone = assign(tone, {
                          [event.target.name]: event.target.checked,
                        });
                        handleToneUpdate(tone);
                      }}
                      // icon={
                      //   <CheckBoxOutlineBlankIcon
                      //     className={classes.sizeIcon}
                      //   />
                      // }
                      // checkedIcon={
                      //   <CheckBoxIcon className={classes.sizeIcon} />
                      // }
                      value="checkedI"
                    />
                  </td>
                  <td>
                    <Select
                      value={tone.experience || ''}
                      onChange={event => {
                        if (event.target.value) {
                          tone = assign(tone, {
                            experience: event.target.value,
                          });
                        } else {
                          delete tone.experience;
                        }
                        handleToneUpdate(tone);
                      }}
                      disableUnderline
                      fullWidth
                      inputProps={{
                        name: 'exp',
                        id: 'exp',
                      }}
                      disabled={disableSelectExperience}
                    >
                      <MenuItem value={''}>
                        <b>None</b>
                      </MenuItem>

                      {experiences.map(e => {
                        return (
                          <MenuItem key={e._id} value={e}>
                            {e.name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </td>
                  <td>
                    <Close
                      size="small"
                      color="#4EA2FF"
                      className={classes.deleteButton}
                      onClick={() => {
                        confirmDelete(selected, tone);
                      }}
                    />
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
};

export class Encoding extends Component {
  constructor(props) {
    super(props);
    this.handleToneUpdate = this.handleToneUpdate.bind(this);
  }

  handleToneUpdate(tone) {
    const { updateTone } = this.props;
    updateTone(tone);
  }

  render() {
    const {
      user,
      classes,
      selected,
      hasEncodings,
      hasTones,
      addTone,
      experiences,
      confirmDelete,
      setToneNumber,
      isRoot,
      encode,
      downloadMedia,
    } = this.props;

    //  console.log('selected', selected);
    // console.log('hasTones', hasTones);

    let isEncode = false;
    if (selected != null && selected.status === 'done') {
      isEncode = true;
    }

    return (
      <div className={classes.container}>
        <div className={classes.topContainer}>
          <div className={classes.title}>Tone Encoding</div>
          {selected && (
            <Button
              color="primary"
              className={classes.button}
              size="small"
              onClick={() => addTone(selected)}
            >
              <MusicNote />
              add tone
            </Button>
          )}
        </div>
        <div className={classes.subTitle}>
          {selected && selected.file && selected.file.name}
        </div>
        {selected && hasTones && (
          <Table
            user={user}
            classes={classes}
            selected={selected}
            handleToneUpdate={this.handleToneUpdate}
            confirmDelete={confirmDelete}
            experiences={experiences}
            setToneNumber={setToneNumber}
            isRoot={isRoot}
          />
        )}
        {selected && (
          <div className={classes.bottomContainer}>
            <Button
              variant="text"
              color="secondary"
              className={classes.button}
              disabled={!hasTones}
              onClick={() => encode(selected)}
            >
              <Fingerprint />
              encode
            </Button>
            <Button
              variant="text"
              color="primary"
              className={classes.button}
              disabled={!hasTones || !isEncode}
              onClick={() => downloadMedia(selected)}
            >
              <CloudDownload />
              &nbsp;download
            </Button>
          </div>
        )}
        {!hasEncodings && 'There are no files in the library to encode'}
      </div>
    );
  }
}

Encoding.propTypes = {
  classes: PropTypes.object.isRequired,
  experiences: PropTypes.array.isRequired,
};

export default withStyles(styles)(Encoding);
